/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { hospitalizationCheckExistingPreHospi } from '../fn/hospitalization/hospitalization-check-existing-pre-hospi';
import { HospitalizationCheckExistingPreHospi$Params } from '../fn/hospitalization/hospitalization-check-existing-pre-hospi';
import { hospitalizationCreateKioskPrehospi } from '../fn/hospitalization/hospitalization-create-kiosk-prehospi';
import { HospitalizationCreateKioskPrehospi$Params } from '../fn/hospitalization/hospitalization-create-kiosk-prehospi';
import { HospitalizationDto } from '../models/hospitalization-dto';
import { hospitalizationGetMedicalFormPdf$Json } from '../fn/hospitalization/hospitalization-get-medical-form-pdf-json';
import { HospitalizationGetMedicalFormPdf$Json$Params } from '../fn/hospitalization/hospitalization-get-medical-form-pdf-json';
import { hospitalizationGetMedicalFormPdf$Pdf } from '../fn/hospitalization/hospitalization-get-medical-form-pdf-pdf';
import { HospitalizationGetMedicalFormPdf$Pdf$Params } from '../fn/hospitalization/hospitalization-get-medical-form-pdf-pdf';
import { hospitalizationGetPrintLightHtml } from '../fn/hospitalization/hospitalization-get-print-light-html';
import { HospitalizationGetPrintLightHtml$Params } from '../fn/hospitalization/hospitalization-get-print-light-html';
import { hospitalizationGetPrintLightPdf$Json } from '../fn/hospitalization/hospitalization-get-print-light-pdf-json';
import { HospitalizationGetPrintLightPdf$Json$Params } from '../fn/hospitalization/hospitalization-get-print-light-pdf-json';
import { hospitalizationGetPrintLightPdf$Pdf } from '../fn/hospitalization/hospitalization-get-print-light-pdf-pdf';
import { HospitalizationGetPrintLightPdf$Pdf$Params } from '../fn/hospitalization/hospitalization-get-print-light-pdf-pdf';
import { hospitalizationSendMedicalForm } from '../fn/hospitalization/hospitalization-send-medical-form';
import { HospitalizationSendMedicalForm$Params } from '../fn/hospitalization/hospitalization-send-medical-form';

@Injectable({ providedIn: 'root' })
export class HospitalizationService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `hospitalizationCheckExistingPreHospi()` */
  static readonly HospitalizationCheckExistingPreHospiPath = '/v1/Hospitalization/CheckExistingPreHospi';

  /**
   * Check existing preHospitalization,   Permissions [AuthenticatedUser] ,   Restricted to [KIOSK_HOME].
   *
   * It will return the existing prehospitalization on your filter criteria
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `hospitalizationCheckExistingPreHospi()` instead.
   *
   * This method doesn't expect any request body.
   */
  hospitalizationCheckExistingPreHospi$Response(params?: HospitalizationCheckExistingPreHospi$Params, context?: HttpContext): Observable<StrictHttpResponse<HospitalizationDto>> {
    return hospitalizationCheckExistingPreHospi(this.http, this.rootUrl, params, context);
  }

  /**
   * Check existing preHospitalization,   Permissions [AuthenticatedUser] ,   Restricted to [KIOSK_HOME].
   *
   * It will return the existing prehospitalization on your filter criteria
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `hospitalizationCheckExistingPreHospi$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  hospitalizationCheckExistingPreHospi(params?: HospitalizationCheckExistingPreHospi$Params, context?: HttpContext): Observable<HospitalizationDto> {
    return this.hospitalizationCheckExistingPreHospi$Response(params, context).pipe(
      map((r: StrictHttpResponse<HospitalizationDto>): HospitalizationDto => r.body)
    );
  }

  /** Path part for operation `hospitalizationCreateKioskPrehospi()` */
  static readonly HospitalizationCreateKioskPrehospiPath = '/v1/Hospitalization/CreateKioskPrehospi';

  /**
   * Create kiosk prehospi,   Permissions [AuthenticatedUser] ,   Restricted to [KIOSK_HOME].
   *
   * It will return the created kiosk prehospitalization on your filter criteria
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `hospitalizationCreateKioskPrehospi()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  hospitalizationCreateKioskPrehospi$Response(params?: HospitalizationCreateKioskPrehospi$Params, context?: HttpContext): Observable<StrictHttpResponse<HospitalizationDto>> {
    return hospitalizationCreateKioskPrehospi(this.http, this.rootUrl, params, context);
  }

  /**
   * Create kiosk prehospi,   Permissions [AuthenticatedUser] ,   Restricted to [KIOSK_HOME].
   *
   * It will return the created kiosk prehospitalization on your filter criteria
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `hospitalizationCreateKioskPrehospi$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  hospitalizationCreateKioskPrehospi(params?: HospitalizationCreateKioskPrehospi$Params, context?: HttpContext): Observable<HospitalizationDto> {
    return this.hospitalizationCreateKioskPrehospi$Response(params, context).pipe(
      map((r: StrictHttpResponse<HospitalizationDto>): HospitalizationDto => r.body)
    );
  }

  /** Path part for operation `hospitalizationGetMedicalFormPdf()` */
  static readonly HospitalizationGetMedicalFormPdfPath = '/v1/Hospitalization/GetMedicalFormPDF';

  /**
   * Get medical form in PDF,   Permissions [AuthenticatedUser] ,   Restricted to [KIOSK_HOME].
   *
   * It will return the medical form in PDF on your filter criteria
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `hospitalizationGetMedicalFormPdf$Pdf()` instead.
   *
   * This method doesn't expect any request body.
   */
  hospitalizationGetMedicalFormPdf$Pdf$Response(params?: HospitalizationGetMedicalFormPdf$Pdf$Params, context?: HttpContext): Observable<StrictHttpResponse<File>> {
    return hospitalizationGetMedicalFormPdf$Pdf(this.http, this.rootUrl, params, context);
  }

  /**
   * Get medical form in PDF,   Permissions [AuthenticatedUser] ,   Restricted to [KIOSK_HOME].
   *
   * It will return the medical form in PDF on your filter criteria
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `hospitalizationGetMedicalFormPdf$Pdf$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  hospitalizationGetMedicalFormPdf$Pdf(params?: HospitalizationGetMedicalFormPdf$Pdf$Params, context?: HttpContext): Observable<File> {
    return this.hospitalizationGetMedicalFormPdf$Pdf$Response(params, context).pipe(
      map((r: StrictHttpResponse<File>): File => r.body)
    );
  }

  /**
   * Get medical form in PDF,   Permissions [AuthenticatedUser] ,   Restricted to [KIOSK_HOME].
   *
   * It will return the medical form in PDF on your filter criteria
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `hospitalizationGetMedicalFormPdf$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  hospitalizationGetMedicalFormPdf$Json$Response(params?: HospitalizationGetMedicalFormPdf$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<File>> {
    return hospitalizationGetMedicalFormPdf$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Get medical form in PDF,   Permissions [AuthenticatedUser] ,   Restricted to [KIOSK_HOME].
   *
   * It will return the medical form in PDF on your filter criteria
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `hospitalizationGetMedicalFormPdf$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  hospitalizationGetMedicalFormPdf$Json(params?: HospitalizationGetMedicalFormPdf$Json$Params, context?: HttpContext): Observable<File> {
    return this.hospitalizationGetMedicalFormPdf$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<File>): File => r.body)
    );
  }

  /** Path part for operation `hospitalizationSendMedicalForm()` */
  static readonly HospitalizationSendMedicalFormPath = '/v1/Hospitalization/SendMedicalForm';

  /**
   * Send medical form,   Permissions [SEND_MEDICAL_FORM] ,   Restricted to [ADMIN|HOSPITAL|INSURER|KIOSK_HOME].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `hospitalizationSendMedicalForm()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  hospitalizationSendMedicalForm$Response(params?: HospitalizationSendMedicalForm$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return hospitalizationSendMedicalForm(this.http, this.rootUrl, params, context);
  }

  /**
   * Send medical form,   Permissions [SEND_MEDICAL_FORM] ,   Restricted to [ADMIN|HOSPITAL|INSURER|KIOSK_HOME].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `hospitalizationSendMedicalForm$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  hospitalizationSendMedicalForm(params?: HospitalizationSendMedicalForm$Params, context?: HttpContext): Observable<void> {
    return this.hospitalizationSendMedicalForm$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `hospitalizationGetPrintLightPdf()` */
  static readonly HospitalizationGetPrintLightPdfPath = '/v1/Hospitalization/GetPrintLightPDF';

  /**
   * Get print light in PDF,   Permissions [AuthenticatedUser] ,   Restricted to [KIOSK_HOME].
   *
   * It will return the print light in PDF on your filter criteria
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `hospitalizationGetPrintLightPdf$Pdf()` instead.
   *
   * This method doesn't expect any request body.
   */
  hospitalizationGetPrintLightPdf$Pdf$Response(params?: HospitalizationGetPrintLightPdf$Pdf$Params, context?: HttpContext): Observable<StrictHttpResponse<File>> {
    return hospitalizationGetPrintLightPdf$Pdf(this.http, this.rootUrl, params, context);
  }

  /**
   * Get print light in PDF,   Permissions [AuthenticatedUser] ,   Restricted to [KIOSK_HOME].
   *
   * It will return the print light in PDF on your filter criteria
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `hospitalizationGetPrintLightPdf$Pdf$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  hospitalizationGetPrintLightPdf$Pdf(params?: HospitalizationGetPrintLightPdf$Pdf$Params, context?: HttpContext): Observable<File> {
    return this.hospitalizationGetPrintLightPdf$Pdf$Response(params, context).pipe(
      map((r: StrictHttpResponse<File>): File => r.body)
    );
  }

  /**
   * Get print light in PDF,   Permissions [AuthenticatedUser] ,   Restricted to [KIOSK_HOME].
   *
   * It will return the print light in PDF on your filter criteria
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `hospitalizationGetPrintLightPdf$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  hospitalizationGetPrintLightPdf$Json$Response(params?: HospitalizationGetPrintLightPdf$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<File>> {
    return hospitalizationGetPrintLightPdf$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Get print light in PDF,   Permissions [AuthenticatedUser] ,   Restricted to [KIOSK_HOME].
   *
   * It will return the print light in PDF on your filter criteria
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `hospitalizationGetPrintLightPdf$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  hospitalizationGetPrintLightPdf$Json(params?: HospitalizationGetPrintLightPdf$Json$Params, context?: HttpContext): Observable<File> {
    return this.hospitalizationGetPrintLightPdf$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<File>): File => r.body)
    );
  }

  /** Path part for operation `hospitalizationGetPrintLightHtml()` */
  static readonly HospitalizationGetPrintLightHtmlPath = '/v1/Hospitalization/GetPrintLightHTML';

  /**
   * Get print light in Html,   Permissions [AuthenticatedUser] ,   Restricted to [KIOSK_HOME].
   *
   * It will return the print light in Html on your filter criteria
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `hospitalizationGetPrintLightHtml()` instead.
   *
   * This method doesn't expect any request body.
   */
  hospitalizationGetPrintLightHtml$Response(params?: HospitalizationGetPrintLightHtml$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return hospitalizationGetPrintLightHtml(this.http, this.rootUrl, params, context);
  }

  /**
   * Get print light in Html,   Permissions [AuthenticatedUser] ,   Restricted to [KIOSK_HOME].
   *
   * It will return the print light in Html on your filter criteria
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `hospitalizationGetPrintLightHtml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  hospitalizationGetPrintLightHtml(params?: HospitalizationGetPrintLightHtml$Params, context?: HttpContext): Observable<string> {
    return this.hospitalizationGetPrintLightHtml$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

}
